import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { focusMainContent, hasFocusInsideMainContent } from 'layouts/SkipToMainContent';

export const FocusOnRouteChange = () => {
  const { pathname } = useLocation();
  const hasPathnameChanged = useRef(false);

  useEffect(() => {
    if (!hasPathnameChanged.current) {
      hasPathnameChanged.current = true;
      return;
    }

    const animationFrameId = window.requestAnimationFrame(() => {
      if (hasFocusInsideMainContent()) return;

      focusMainContent();
    });

    return () => {
      window.cancelAnimationFrame(animationFrameId);
    };
  }, [pathname]);

  return null;
};
